import {GetAnalysisPipelineStep, GetAnalysisStepData} from 'analysis-tool/AnalysisTypes';
import {assert} from 'Asserts';

export function getOutputStepDataFromStep(
  step: GetAnalysisPipelineStep,
  stepDataId: string
): GetAnalysisStepData {
  const stepData = step.outputStepDatas.find((stepData) => stepData.id === stepDataId);
  assert(stepData != null, 'Could not find step data', {stepDataId});
  return stepData;
}
